import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';

import { DrawerService, Drawer } from '../../drawer.service';

@Component({
  selector: 'uex-drawer-wrapper',
  templateUrl: './wrapper.component.html',
})
export class DrawerWrapperComponent implements OnInit {
  constructor(
    private drawerService: DrawerService
  ) { }

  public get drawers(): Array<Drawer> {
    return this.drawerService.drawers;
  }

  ngOnInit() { }
}
